import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import OrderDetailInfoTable from './OrderDetail/OrderDetailInfoTable';
import { GetOrderArticleInfoForOrderInfoTable, getTotalQuantityOfBOMInMaterials } from '../../Helpers/OrderInfoHelper'

export default function OrderInfo(props) {
    const classes = useStyles();

    return <div className={classes.orderInfo}>
        <div className={classes.label}>
            Ordern°
        </div>
        <div className={classes.info}>
            <div className={classes.reference}>
                {props.productionOrder.reference}
            </div>
            <div className={classes.quantity}>
                {"Totaal gewicht:  " + String(parseInt(getTotalQuantityOfBOMInMaterials(props.productionOrder))) + "kg"}
            </div>
        </div>
        <OrderDetailInfoTable rows={GetOrderArticleInfoForOrderInfoTable(props.productionOrder.bomOut[0])}></OrderDetailInfoTable>
    </div>
}

const useStyles = makeStyles({
    orderInfo: {
        float: "left",
        paddingLeft: "30px",
        width: "100%",
        boxSizing: "border-box",
        display: 'flex',
        flexDirection: 'column',
        marginBottom: "20px"
    },
    reference: {
        float: "left",
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        marginBottom: "10px"

    },
    quantity: {
        float: "right",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        marginBottom: "10px"

    },
    label: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        display: "block",
        marginTop: "15px"
    },
    info: {

        color: "#020100",
        display: "block",
    },
    orderTable: {
        display: "block"
    },
    nameCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        width: "100px"
    },
    infoCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
    },
    paper: {
        boxShadow: 'none'
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
        },
    }
});